var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000036231904150724346760000003156299210841516710_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_137",
    fill: "#58c87e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m313.6 251.8c-24.8-27.4-55.8-47-90.2-55.6-25.3 9.9-53.4 9.9-78.8 0-69.5 17.3-125 79.6-144.1 160.1-1.4 5.9-.1 12.1 3.6 16.9 58.5 76.2 158.6 107.2 250 77.6-39.1-69.4-14.5-157.4 54.9-196.5 1.6-.9 3.1-1.8 4.6-2.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 95.6,
    r: 95.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380 248c-72.9 0-132 59.1-132 132s59.1 132 132 132 132-59.1 132-132-59.1-132-132-132zm74.4 88.8-97.7 97.7c-3.1 3.1-8.2 3.1-11.3 0l-39.8-39.8c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l34.1 34.1 92-92c3-3.2 8.1-3.3 11.3-.3s3.3 8.1.3 11.3c0 .1-.1.2-.2.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ac5f74fb51926c34f793409eb5b8617b.svg";
export { ForwardRef as ReactComponent };